export default __webpack_public_path__ + "static/media/rating.478d6466.svg";